/**
 * Payment Installments Tabs Component
 * Handles tab switching and variant price updates
 */

(() => {
  if (window.__GORAL_PAYMENT_INSTALLMENTS_TABS_INIT__) {
    return;
  }

  window.__GORAL_PAYMENT_INSTALLMENTS_TABS_INIT__ = true;

  class PaymentInstallmentsTabs extends HTMLElement {
    constructor() {
      super();
      this.installmentsCount = parseInt(this.dataset.installmentsCount) || 3;
      this.tabs = this.querySelectorAll('.payment-installments-tabs__tab');
      this.panels = this.querySelectorAll('.payment-installments-tabs__panel');
      this.onVariantChange = null;
      this.onPickerChange = null;
      this.variantPicker = null;
    }

    connectedCallback() {
      this.setupTabs();
      this.setupVariantListener();
    }

    disconnectedCallback() {
      if (this.onVariantChange) {
        document.removeEventListener('variant:change', this.onVariantChange);
      }

      if (this.variantPicker && this.onPickerChange) {
        this.variantPicker.removeEventListener('change', this.onPickerChange);
      }
    }

    setupTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const targetPanel = tab.dataset.tab;
          this.switchTab(targetPanel);
        });
      });
    }

    switchTab(targetPanel) {
      // Update tabs
      this.tabs.forEach(tab => {
        if (tab.dataset.tab === targetPanel) {
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');
        } else {
          tab.classList.remove('active');
          tab.setAttribute('aria-selected', 'false');
        }
      });

      // Update panels
      this.panels.forEach(panel => {
        if (panel.dataset.panel === targetPanel) {
          panel.classList.add('active');
        } else {
          panel.classList.remove('active');
        }
      });
    }

    setupVariantListener() {
      // Listen for variant change events
      this.onVariantChange = (event) => {
        if (!this.isConnected) {
          return;
        }

        const eventFormId = event?.detail?.formId;
        if (eventFormId && this.closest('form') && this.closest('form').id && eventFormId !== this.closest('form').id) {
          return;
        }

        if (event.detail && event.detail.variant) {
          this.updateInstallmentPrices(event.detail.variant);
        }
      };

      document.addEventListener('variant:change', this.onVariantChange);

      // Also listen for the more common variant change pattern
      this.variantPicker = document.querySelector('variant-picker, variant-radios, variant-selects');
      if (this.variantPicker) {
        this.onPickerChange = () => {
          if (!this.isConnected) {
            return;
          }

          const selectedVariant = this.getSelectedVariant();
          if (selectedVariant) {
            this.updateInstallmentPrices(selectedVariant);
          }
        };

        this.variantPicker.addEventListener('change', this.onPickerChange);
      }
    }

    getSelectedVariant() {
      // Try to get selected variant from various sources
      const form = this.closest('product-form') || document.querySelector('product-form');
      if (form && form.currentVariant) {
        return form.currentVariant;
      }

      // Alternative: get from variant input
      const variantInput = document.querySelector('[name="id"]');
      if (variantInput && variantInput.value) {
        const productData = document.querySelector('[data-product-json]');
        if (productData) {
          try {
            const product = JSON.parse(productData.textContent);
            return product.variants.find(v => v.id == variantInput.value);
          } catch (e) {
            console.error('Error parsing product data:', e);
          }
        }
      }

      return null;
    }

    updateInstallmentPrices(variant) {
      if (!variant || !variant.price) return;

      const installmentPrice = Math.round(variant.price / this.installmentsCount);
      const priceElements = this.querySelectorAll('.payment-installments-tabs__price');
      
      priceElements.forEach(priceEl => {
        // Use Shopify's money formatting if available
        if (window.Shopify && window.Shopify.formatMoney) {
          let formattedPrice = window.Shopify.formatMoney(installmentPrice, window.theme.moneyFormat || '{{amount}}');
          // Remove trailing zeros
          formattedPrice = formattedPrice.replace(/[.,]00$/, '');
          priceEl.textContent = formattedPrice;
        } else {
          // Fallback to simple formatting
          const price = (installmentPrice / 100).toFixed(2).replace(/\.00$/, '');
          priceEl.textContent = price;
        }
      });
    }
  }

  if (!customElements.get('payment-installments-tabs')) {
    customElements.define('payment-installments-tabs', PaymentInstallmentsTabs);
  }
})();
